import { SizeClass } from "./SizeClass";

export const isDense = (sizeClass: SizeClass): boolean => {
  return sizeClass === SizeClass.Expanded || sizeClass === SizeClass.ExtraLarge;
};
